/**
 * Utility functions for handling contact exports
 */

import { message } from "antd";
import { api } from "../../../api";
import { buildUIFilters } from "./filterUtils";

/**
 * Get export actions based on customer type
 */
export const getExportActions = (userMail, customer, filterGroups = []) => {
  const messageContent =
    "Your data is exporting... We will send you an email with a link to download the file.";
  const exportActions = [
    {
      label: "Export all contacts",
      onClick: async () => {
        message.loading(messageContent);

        const customerId = customer.id;

        if (customer.shouldEncryptPI) {
          await api.exportEncryptedCustomerAllContacts({
            customerId,
            userEmail: userMail,
            isFromExportButton: true,
          });
        } else {
          await api.exportAllContacts({
            customerId,
            userEmail: userMail,
          });
        }
      },
    },
  ];

  // Add "Export selected contacts" option only when filters are applied
  if (filterGroups.length > 0) {
    exportActions.push({
      label: "Export selected contacts",
      onClick: async () => {
        message.loading(messageContent);

        const customerId = customer.id;

        // Convert filter groups to API format
        const filters = buildUIFilters(filterGroups);

        if (customer.shouldEncryptPI) {
          await api.exportEncryptedCustomerAllContacts({
            customerId,
            userEmail: userMail,
            isFromExportButton: true,
            filters,
          });
        } else {
          await api.exportAllContacts({
            customerId,
            userEmail: userMail,
            filters,
          });
        }
      },
    });
  }

  return exportActions;
};
